import { Navigate, useLocation } from 'react-router-dom';
import { loanCenterInternalPath } from '@/components/encompass/prospects/loanCenterDeepLink';

export function LoanCenterRedirect() {
  const location = useLocation();
  return <Navigate to={loanCenterInternalPath(location.search)} replace />;
}
